/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 VN — WEB-20261019-suzitee-cart-variant-empty
   Đã làm: nút CONTINUE SHOPPING giỏ rỗng về trang chủ "/" (trang /cart); trong drawer bấm nút -> đóng drawer rồi về "/". */
(function(){try{
  function fix(){var a=document.querySelectorAll('#shopify-section-cart-template a.cart__continue-shopping');for(var i=0;i<a.length;i++){if(a[i].getAttribute('href')!=='/')a[i].setAttribute('href','/');}}
  if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
  document.addEventListener('click',function(e){var b=e.target&&e.target.closest&&e.target.closest('.szmc-dw__cs');if(!b)return;
    try{var c=document.querySelector('.szmc-dw__close');if(c)c.click();}catch(x){}
    if(location.pathname==='/'){e.preventDefault();}},true);
}catch(e){}})();
